import { formatDate } from '@frontend/mwm-ui'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import { MILLISECONDS_IN_NANO } from '~/const'

const DateCellRenderer = ({ value }: ICellRendererParams<unknown, number>): ReactElement => {
  return <span className="text">{value ? formatDate(value / MILLISECONDS_IN_NANO) : ''}</span>
}

export default DateCellRenderer
